/**
 * * Получить дефолтную дату для дедлайна
 * @returns
 */
export const getDefaultDedlineDate = () => {
  const now = new Date();
  let nextBusinessDay = new Date(now); // Создаем копию текущей даты

  const dayOfWeek = now.getDay(); // 0 - Воскресенье, 1 - Понедельник, ..., 6 - Суббота

  // Определяем сколько дней добавить
  if (dayOfWeek === 5) {
    // Пятница -> Понедельник
    nextBusinessDay.setDate(now.getDate() + 3);
  } else if (dayOfWeek === 6) {
    // Суббота -> Понедельник
    nextBusinessDay.setDate(now.getDate() + 2);
  } else {
    // Любой другой будний день -> следующий день
    nextBusinessDay.setDate(now.getDate() + 1);
  }

  // Устанавливаем время на 17:00
  nextBusinessDay.setHours(17, 0, 0, 0);

  return nextBusinessDay;
};
